/**
 * Services page
 *
 * created by Ty D'Angelo 11/06/2022
 */

import * as React from "react";
import { useState, useEffect } from "react";
import { getCookie } from "../utils/cookies";
import axios from "axios";
import ViewServiceTypes from "../services/view/ViewServiceTypes";
import { CenteredContainer } from "../ui/BaseComponents";
import ServicesByProvider from "../services/view/ServicesByProvider";

export default function Services() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  // GET
  const fetchData = async () => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data } = await axios("https://ea1-dev.azurewebsites.net/api/serviceType", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: JWT,
        },
      });
      setData(data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      alert("error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CenteredContainer>
        <ViewServiceTypes
          fetchData={fetchData}
          data={data}
          isLoading={isLoading}
        />
      </CenteredContainer>
      <CenteredContainer>
        <ServicesByProvider data={data} fetchData={fetchData} />
      </CenteredContainer>
    </>
  );
}
